// extracted by mini-css-extract-plugin
module.exports = {"winnerSegment":"K6bW807cYnVBmMhF4k_Ea","subHeader":"JLHTIUad2S4r7IHz70CgT"};